import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs";

import { Option } from "@shared/Entities/General/option.entity";
import { SharedOptionsService } from "@shared/Services/shared-options.service";

import { NewUserPersonalData } from "../../Types/new-user";

@Component({
  selector: "app-personal-data-form",
  templateUrl: "./personal-data-form.component.html",
})
export class PersonalDataFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public provinces$: Observable<Option[]>;
  public identificationTypes$: Observable<Option[]>;

  @Output() public submitForm = new EventEmitter<NewUserPersonalData>();
  @Input() public set personalData(newPersonalData: NewUserPersonalData | null) {
    newPersonalData ? this.form.patchValue(newPersonalData) : this.form?.reset();
  }

  constructor(private formBuilder: UntypedFormBuilder, private sharedOptionsService: SharedOptionsService) {}

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      identificationType: [null, Validators.required],
      identification: ["", Validators.required],
      name: ["", Validators.required],
      lastName: ["", Validators.required],
      province: [null, Validators.required],
      telephone: ["", Validators.required],
      birthDate: ["", Validators.required],
    });

    this.provinces$ = this.sharedOptionsService.getProvinces();
    this.identificationTypes$ = this.sharedOptionsService.getIdentificationTypes();
  }

  public onSubmit(): void {
    this.submitForm.emit(this.form.value);
  }
}
